



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import imgs from '@/util/imgs.ts';

@Component
export default class QQSideBar extends Vue {
  get lang() {
    return this.$store.state.lang;
  }
  /**
   * 客服qq号数组
   */
  @Prop()
  private qqAccounts!: string[];
  private imgs = imgs;

  /**
   * 是否启动自动找上次聊过的客服
   * true表示启动
   */
  @Prop({ default: false })
  private findLastCustomerService!: boolean;

  get isActive() {
    return this.$store.state.onlineCustomActive;
  }

  /**
   * 根据传入的qqAccounts属性，生产qq连接对象数组
   */
  get qqCustomerLinks() {
    const links = this.qqAccounts.map((item, index) => {
      return {
        id: `customer${index}`,
        href: `http://wpa.qq.com/msgrd?v=3&uin=${item}&site=qq&menu=yes`,
        account: item,
      };
    });
    return links;
  }

  /**
   * 打开/关闭在线客服侧边栏的处理方法
   */
  private activeCustomSideBarHandler() {
    const currentStatus = this.$store.state.onlineCustomActive;
    this.$store.dispatch('setOnlineCustomActive', !currentStatus);
  }

  /**
   * 点击在线客服的处理方法
   * 从local storage中查询上次保存过的客服id
   * 没有保存过则随机找一个客服
   * 读取本地保存的客服id
   * 用于下次寻找在线客服的时候可以找到同一个客服
   */
  private onlineChatHandler() {

    // 从local storage中查询上次保存过的客服id
    // 没有保存过则随机找一个客服
    let customerServiceId: any = this.getRandom(0, this.qqAccounts.length - 1);

    if (this.findLastCustomerService) {
      // 读取本地保存的客服id
      customerServiceId = this.getCustomerIdFromLocalStorage() || customerServiceId;
      // 保存客服id
      this.saveCustomerIdToLocalStorage(customerServiceId + '');
    }

    const id = `customer${customerServiceId}`;
    const $link: any = this.$refs[id];

    // 点击链接，跳转到qq的在线对话页面
    $link[0].click();
  }

  /**
   * 获取范围是 min 到 max 的随机数
   */
  private getRandom(min: number, max: number): number {
    let maxNum = 0;
    let minNum = 0;
    if (max > min) {
      maxNum = max;
      minNum = min;
    } else {
      maxNum = min;
      minNum = max;
    }

    const result = Math.floor(Math.random() * (maxNum - minNum + 1)) + minNum;
    return result;
  }
  /**
   * 保存当前已有过对话的客服id到本地缓存,
   * 用于下次寻找在线客服的时候可以找到同一个客服
   */
  private saveCustomerIdToLocalStorage(id: string) {
    window.localStorage.setItem('last_customer_service_id', id);
  }

  /**
   * 从本地缓存中读取在线客服id
   */
  private getCustomerIdFromLocalStorage() {
    return window.localStorage.getItem('last_customer_service_id');
  }
}
